// src/pages/Login.jsx

import Hero from "../component/header";
import Footer from "../component/Footer";
import Login from "../component/Login";

const Home = () => {
  return (
    <div className="App">
      <Hero isBlack={true} />

      <div className="py-[100px]">
        <Login />
      </div>

      <Footer />
    </div>
  );
};

export default Home;
